var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero has-background-info"},[_c('div',{staticClass:"container has-text-centered is-fluid"},[_c('br'),_c('KohdeluetteloKartta')],1),_c('aaltotausta'),_c('keksi')],1)}
var staticRenderFns = []

export { render, staticRenderFns }